export const generateHealthSegments = inputs => {
    let scores = calculateScores(inputs);

    scores = sortByDescScore(scores);

    return scores.map(score => score.segment);
};

const sortByDescScore = scores => {
    scores.sort((a, b) => {
        if (a.score > b.score) {
            return -1;
        }
        return 1;
    });

    return scores;
};

const calculateScores = inputs => {
    const scores = [];

    for (const key in functionMapping) {
        const func = functionMapping[key];

        const score = sumProduct(inputs, func.weights) + func.constant;

        scores.push({
            segment: func.segment,
            score
        });
    }

    return scores;
};

const sumProduct = (arr1, arr2) => {
    let sum = 0;

    for (let i = 0; i < arr1.length; i++) {
        sum += arr1[i] * arr2[i];
    }

    return sum;
};

const functionMapping = {
    f1: {
        id: 1,
        segment: 'Holistic Healer',
        weights: [
            1.3549992,
            2.18726087,
            1.29208026,
            1.39913547,
            -0.05610488,
            3.14186135,
            7.75737174,
            0.45306388,
            3.96117873,
            1.49562716,
            0.42837603,
            3.00238215,
            4.8701381,
            3.72198538,
            1.32047278,
            -0.13848978,
            1.3756237,
            0.75319072,
            -0.67781496,
            0.93385423,
            10.90109214,
            10.7525086,
            11.41926889,
            10.94865742,
            0,
            0,
            0,
            0,
            0,
            2.22767449,
            2.66473606,
            0.85684056,
            1.33072837,
            0.56469602,
            0.74118589,
            0.72176552,
            0.39800723,
            1.63551974,
            0.44262386,
            -0.02552923,
            1.42065555,
            1.30922894,
            0.6066765
        ],
        constant: -56.02312536
    },
    f2: {
        id: 2,
        segment: 'Medically Minded',
        weights: [
            1.4714243,
            1.77990029,
            1.16344161,
            1.73489313,
            -4.31356251,
            -1.07655234,
            1.71628721,
            0.06964288,
            -0.27344089,
            -0.59379061,
            0.81529506,
            3.11886549,
            4.88973014,
            3.48578242,
            1.0130845,
            -0.57316937,
            1.23894069,
            0.97798168,
            -1.20823867,
            0.44743566,
            11.78528489,
            11.18776727,
            12.31124796,
            11.69958657,
            0,
            0,
            0,
            0,
            0,
            2.37850598,
            2.78664433,
            0.97225389,
            1.08277579,
            0.54166276,
            0.23759592,
            0.64951989,
            1.1946776,
            0.95899149,
            -0.61535625,
            0.25817028,
            0.12288526,
            0.31620711,
            -0.86344334
        ],
        constant: -49.14042484
    },
    f3: {
        id: 3,
        segment: 'Vital Achiever',
        weights: [
            1.04253645,
            1.67395655,
            1.39122794,
            1.41410919,
            -4.77478972,
            -0.83213098,
            1.12361653,
            1.57484986,
            -1.13058738,
            -0.42220813,
            -0.29562936,
            2.48979301,
            5.25800477,
            3.61174155,
            1.46996658,
            -0.52990277,
            1.26249059,
            0.5486777,
            -0.84729237,
            0.87542726,
            11.46860658,
            12.45132797,
            11.74849916,
            12.54797842,
            0,
            0,
            0,
            0,
            0,
            2.00593919,
            2.55337615,
            1.30069402,
            0.75915122,
            0.72999577,
            1.89304873,
            0.67197211,
            -0.51969814,
            1.54600998,
            0.43727985,
            -0.90518393,
            -0.36073291,
            0.30077347,
            -1.38211422
        ],
        constant: -48.77163132
    },
    f4: {
        id: 4,
        segment: 'Connection Seeker',
        weights: [
            1.09761949,
            1.90454369,
            1.40909033,
            1.39946911,
            -4.53977322,
            -0.49399865,
            1.89779742,
            -1.34790661,
            -0.99949187,
            -0.31796344,
            0.38581628,
            1.5774146,
            4.3910377,
            4.04522611,
            1.07629802,
            -0.66627183,
            1.61081757,
            0.36023313,
            -1.14917647,
            1.34107044,
            11.37440523,
            11.93199824,
            11.60714916,
            12.02615923,
            0,
            0,
            0,
            0,
            0,
            1.94045894,
            2.59916551,
            1.5696006,
            0.79108824,
            1.05518393,
            0.41335816,
            -0.10200256,
            0.09524376,
            2.21929521,
            0.92896135,
            -0.63470794,
            0.86518531,
            0.58473869,
            -0.50739153
        ],
        constant: -47.96974591
    },
    f5: {
        id: 5,
        segment: 'Driven Caretaker',
        weights: [
            1.83728112,
            1.89917374,
            1.96512264,
            1.78459297,
            -7.00395305,
            -1.09565254,
            3.73101958,
            0.22866951,
            0.48570854,
            0.61082219,
            -0.81150248,
            1.96363909,
            5.71004284,
            4.50887561,
            1.3222958,
            0.60606847,
            1.72573951,
            0.67842784,
            -0.06204543,
            0.98571618,
            8.89382292,
            8.06485683,
            8.58365354,
            8.31255536,
            0,
            0,
            0,
            0,
            0,
            1.96018375,
            2.640867,
            1.69936751,
            0.97632025,
            1.17607435,
            0.56994261,
            -0.32706329,
            -0.03861661,
            1.12327788,
            -0.14215005,
            -0.76855793,
            -0.11413042,
            -0.12318905,
            -0.61051688
        ],
        constant: -62.7015209
    },
    f6: {
        id: 6,
        segment: 'Laid-back Learner',
        weights: [
            1.39311804,
            1.44640575,
            1.4886938,
            1.56204138,
            -4.75598922,
            -1.24777981,
            0.98436266,
            -0.52382632,
            -0.78327236,
            -0.35246624,
            -0.87653726,
            1.9815041,
            4.91478243,
            3.86394425,
            1.05941663,
            -0.19025751,
            1.22233689,
            0.20308626,
            -1.016606,
            0.6214198,
            12.07607226,
            11.69185291,
            11.0960627,
            11.10297317,
            0,
            0,
            0,
            0,
            0,
            1.35881978,
            2.00418488,
            1.35054468,
            0.54010595,
            0.82634995,
            0.18535324,
            -0.25151081,
            -0.04467214,
            0.85776696,
            -0.14872212,
            -0.66164654,
            0.25143842,
            0.0594904,
            -0.86474643
        ],
        constant: -39.90746268
    }
};
